import React, { FC } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

interface Route {
  hard?: boolean,
  name: string,
  link: string
}

const UserAdmin: FC<RouteComponentProps> = (props) => {
  let settingsRoute = {name: 'Settings', link: "/n/admin/organization-settings"}
  let usersRoute = {name: 'Users', link: "/n/admin/users"}
  let userGroupsRoute = {name: 'User Groups', link: "/n/admin/user-groups"}
  let auditlog = {name: 'Audit Log', link: "/n/admin/audit-log"}

  let tabs: Route[] = [
    settingsRoute,
    usersRoute,
    userGroupsRoute,
    auditlog
  ]

  return (
    <Container_s>
      <Subnav section="ORGANIZATION SETTINGS" tabs={tabs}/>
      <Content_s>
        {props.children}
      </Content_s>
    </Container_s>
  )
}

export default UserAdmin
